module.exports = __webpack_public_path__ + "img/jl-17.aed4bd95.png";